import { baseURL as upperBaseURL } from '../baseURL'
import { Section } from '../sections'


export const baseURL = `${upperBaseURL}/${Section.OrgGroups}`
